import React, { ReactElement } from "react";
import { ToelichtingVerduurzamingHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";

export const ToelichtingAdviesVerduurzamingChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingVerduurzamingHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text="Verduurzaming" level={3} />
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk?.advies}
          keuze={hoofdstuk?.keuze}
        />
      </div>
    </Chapter>
  );
};
